<template>
  <v-menu
    v-model="showCalendar"
    transition="slide-y-transition"
    :close-on-content-click="false"
    offset-y
    :disabled="disabled"
    >

    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="datesLabel"
        append-icon="mdi-calendar"
        :hide-details="true"
        :disabled="disabled"
        v-bind="attrs"
        v-on="on"
        readonly
        outlined
        :rounded="rounded"
        :dense="dense"
        class="input-calendario">
      </v-text-field>
    </template>

    <v-date-picker
      v-model="dates"
      :color="variables.colorPrimary"
      :close-on-content-click="false"
      no-title
      scrollable
      :disabled="disabled"
      range
      :width="dateWidth"
      class="calendario"
      >

      <v-spacer/>
      <v-btn text color="primary" @click="showCalendar = false">Cancel</v-btn>
      <v-btn text color="primary" @click="showCalendar = false">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import variables from '@/assets/styles/helpers/_variables.scss'
import moment from 'moment'
import { map } from 'lodash'
import Events from '@/core/service/events'

export default {
  name: 'OrganizzeCalendar',
  props: {
    getDates: {
      type: Function,
      default: (() => {})
    },

    dense: {
      type: Boolean,
      default: false,
      required: false
    },
    rounded: {
      type: Boolean,
      default: false,
      required: false
    },
    dateWidth:{
      type: String,
      default: (() => {})
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  directives: {},
  components: {},
  data: () => ({
    showCalendar: false,
    datesLabel: [moment().format('DD/MM/YYYY')],
    sortedDates: [moment().format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')],
    dates: [moment().format('YYYY-MM-DD')]
  }),
  created () {},
  mounted () {
    const self = this
    self.getDates(self.createResponse(self.sortedDates))
  },
  computed: { variables: () => variables },
  watch: {
    dates () {
      const self = this
      self.sortedDates = map(map(self.dates, date => moment(date).valueOf()).sort(), time => moment(time).format('YYYY-MM-DD'))
      self.datesLabel = map(self.sortedDates, date => moment(date).format('DD/MM/YYYY')).join(' ~ ')
      self.getDates(self.createResponse(self.sortedDates))
    },
    showCalendar (val) {
      if(!val) {
        Events.$emit('organizzeCalendar::close-on-content-click', {
          startDate: this.sortedDates[0],
          endDate: this.sortedDates[1] || this.sortedDates[0]
        });
      }
    }
  },
  methods: {
    createResponse (val) {
      return { startDate: val[0], endDate: val[1] || val[0] }
    },
    reset () {
      const self = this
      self.dates = [moment().format('YYYY-MM-DD')]
    }
  },
  validations () { return {} }
}
</script>
<style lang="scss" scoped>

.input-calendario::v-deep {
  i {
    color: #4b465c !important;
  }

  & fieldset {
    background: #7C7C8A !important;
  }

  & .v-label {
    color: #7C7C8A !important;
  }

  & input {
    color: #7C7C8A !important;
  }

  &.v-text-field--rounded {
    border-radius: 8px !important
  }

  fieldset {
    background: #1D1D29 !important;
  }
  
  &.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot fieldset {
    background: #1D1D29 !important;
  }
  
  &.v-input.v-input--hide-details.v-input--is-label-active.v-input--is-dirty.v-input--is-readonly.v-input--dense.theme--light.v-text-field.v-text-field--is-booted.v-text-field--enclosed.v-text-field--outlined.v-text-field--rounded {
    background: #1D1D29 !important;
  }
}
  

.calendario::v-deep {  
  .v-btn__content {
    color: rgba(250, 244, 244, 0.87);
  }
  
  .v-picker__body > div, .v-picker__actions {
    background: #1D1D29 !important;
  }
  
  .theme--light.v-date-picker-header .v-date-picker-header__value:not(.v-date-picker-header__value--disabled) button:not(:hover):not(:focus) {
    color: white !important;
  }
  
  .theme--light.v-date-picker-table th, .theme--light.v-date-picker-table .v-date-picker-table--date__week {
    color: white !important;
  }
}

  
</style>